import Customers from "./Customers";
import Title from "./Title";
export default function HappyCustomers(props){

    const customer = props && props.customers;



    return <>
    <div className="happyCustomers pt-4 pt-md-5 pb-3 pb-md-5  mt-md-5 mt-0 mb-0 mb-md-4" >
        <div className="container" >
            <Title mainClass=" d-table m-auto mb-3"
            subheading="See Our Review"
            subclass="m-auto d-table"
            titleclass="md heading text-dark text-center mb-2 mt-2"
            desclass="mb-0"
            title={<>hear from our happy customers!</>}
            />
        </div>  
        <Customers customersData={customer} />
    </div>
    </>
}